export const CLAIMS_SUPPORT = "(866) 311-7243";
export const GENERAL_SUPPORT = "(800) 481-0661";
export const POLICY_SERVICES = "(877) 304-4785";
